import ApiService from '../api.service';

const MyOfferedResource = {
  index: (params) => ApiService.query(`/v1/business/${params.business_id}/credit_offereds`, params.payload),
  availableYears: (businessId) => ApiService.get(`/v1/business/${businessId}/credit_offereds/available_years`),
  delete: (params) => ApiService.delete(`/v1/business/${params.business_id}/credit_offereds/${params.id}`),
  update: (params) => ApiService.put(`/v1/business/${params.business_id}/credit_offereds/${params.id}`, params.payload),
};

export default MyOfferedResource;
